import { MonitorPlay, Zap, MonitorSmartphone, MousePointerClick, Headset, ShieldCheck, Tv, Smartphone, Apple, Cast } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const FEATURES = [
  { icon: MonitorPlay, title: "HD / Full HD Streaming", desc: "Crisp, high-quality picture on every stream." },
  { icon: Zap, title: "Fast Streaming", desc: "Optimised delivery for smooth, buffer-free playback." },
  { icon: MonitorSmartphone, title: "Multi-Device Compatibility", desc: "One hub across all of your screens." },
  { icon: MousePointerClick, title: "Easy Setup", desc: "Step-by-step instructions in just minutes." },
  { icon: Headset, title: "Customer Support", desc: "Real help, whenever you need it — 24/7." },
  { icon: ShieldCheck, title: "Secure Ordering", desc: "Your details stay protected at checkout." },
  { icon: Tv, title: "Smart TV Compatibility", desc: "Built for modern smart television sets." },
  { icon: Smartphone, title: "Android Compatibility", desc: "Phones, tablets and Android TV boxes." },
  { icon: Apple, title: "iOS Compatibility", desc: "iPhone and iPad ready out of the box." },
  { icon: Cast, title: "Streaming Devices", desc: "Works with popular supported streaming devices." },
];

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-28" data-testid="features-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="Features"
          title="Engineered for a premium experience"
          sub="From picture quality to security, every detail of IPTV HUB is designed to feel effortless."
        />
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={(i % 5) * 0.06} className="h-full">
              <div
                data-testid={`feature-card-${f.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="glass glass-hover group h-full rounded-2xl p-6"
              >
                <f.icon className="mb-4 h-6 w-6 text-electric transition-transform duration-300 group-hover:scale-110" />
                <h3 className="font-display text-sm font-semibold text-slate-900">{f.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-slate-500">{f.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
